import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceFormat',
  pure: true,
  standalone: true
})
export class PriceFormatPipe implements PipeTransform {
  transform(
    value: number | null | string | undefined,
    noRounding: boolean = false,
    locale: string = 'fr-FR'
  ): string {
    if (value === null || value === undefined) {
      return '0';
    }

    const amount = Number(value);
    if (!Number.isFinite(amount)) return '-';

    if (noRounding) {
      const parts = String(value).split('.');
      const integerPart = Math.trunc(amount);
      const formattedInteger = integerPart.toLocaleString(locale, {
        maximumFractionDigits: 0,
        useGrouping: true
      });

      if (parts.length > 1) {
        const decimalSeparator =
          new Intl.NumberFormat(locale)
            .formatToParts(1.1)
            .find(p => p.type === 'decimal')?.value ?? ',';
        return `${formattedInteger}${decimalSeparator}${parts[1]}`;
      }

      return formattedInteger;
    }

    return amount.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      useGrouping: true
    });
  }
}
